/**
 * Cloud transition destinations.
 *
 * License Parser has been migrated to the OpenLM Cloud Platform. These URLs drive
 * the transition modals (Sign up / Log in) and the anonymous home-page CTA card.
 *
 * NOTE: the values below are the Dev/QA endpoints provided in the transition spec.
 * The US and EU register URLs are intentionally identical for now; when the real
 * per-region (and production) URLs are known, override them here or move this block
 * into the per-environment `environment.*.ts` files.
 */
export type CloudRegion = 'us' | 'eu';

export const TransitionUrls = {
  // Sign up is the same everywhere.
  signUp: 'https://www.openlm.com/free-trial/?utm_source=legacy_parser&utm_medium=cpc&utm_campaign=parser&legacyParser=true&email=',
  // Region-specific cloud register/login URLs. The `email` query param is appended
  // at runtime from the email used during the real backend sign in.
  loginRegister: {
    us: 'https://cloud-us.openlm.com/identity/Account/Register/?legacyParser=true&redirect=/license-parser',
    eu: 'https://cloud-eu.openlm.com/identity/Account/Register/?legacyParser=true&redirect=/license-parser'
  }
};

/**
 * Builds the cloud login/register URL for the given region, appending the signed-in
 * email when available.
 */
export function buildCloudLoginUrl(region: CloudRegion, email?: string): string {
  const base = region === 'eu' ? TransitionUrls.loginRegister.eu : TransitionUrls.loginRegister.us;
  return email ? base + '&email=' + encodeURIComponent(email) : base;
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/transition-urls.ts